export const CAMPAIGN_API_IFRAME = "82bcccae-c414-43a0-9f90-56535c090d39";
export const ADS_EDITOR_IFRAME = "b8921e92-4fad-4215-9fb0-b110b591df36";
